
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Postpubertal_sex_cord",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Postpubertal_sex_cord.vue